import React from 'react';
import TatvarTulugch from './tatvarTulugch';

const PageList = () => <TatvarTulugch />;

export default PageList;
